import React, { useMemo } from "react";
import moment from "moment-timezone";
import { FilterContext, UserContext, AccordionContext } from "../index";
import "./WorkfolioMaintenance.css";
import Profile from "./../img/workfolio-latest-old.png";
import Button from "react-bootstrap/Button";
import { Helmet } from "react-helmet";
var WorkfolioMaintenance = function WorkfolioMaintenance(props) {
  var currentUTCTime = moment.utc().format('HH:mm A');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "Workfolio Maintenance")), /*#__PURE__*/React.createElement("div", {
    className: "workfolio-maintenance-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "workfolio-maintenance-header"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Workfolio",
    src: Profile,
    className: "workfolio-maintenance-img-responsive workfolio-maintenance-img-center m-b-20",
    width: "90"
  }), /*#__PURE__*/React.createElement("h2", {
    className: "workfolio-maintenance-header-h2"
  }, "Workfolio ")), /*#__PURE__*/React.createElement("div", {
    className: "workfolio-maintenance-body-content"
  }, /*#__PURE__*/React.createElement("p", {
    className: "workfolio-maintenance-body-content-success-p"
  }, "Maintenance has been completed successfully!"), /*#__PURE__*/React.createElement("div", {
    className: "workfolio-maintenance-body-content-button-div-success"
  }, /*#__PURE__*/React.createElement("a", {
    className: "workfolio-maintenance-body-content-button",
    href: "https://app.getworkfolio.com/login",
    target: "_blank",
    "data-saferedirecturl": "https://app.getworkfolio.com/login"
  }, "Click to visit Workfolio")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    className: "workfolio-maintenance-footer"
  }, "If you need any support, please Contact Support", /*#__PURE__*/React.createElement("a", {
    className: "workfolio-maintenance-body-content-button-1-success",
    href: "https://tawk.to/workfolio",
    target: "_blank",
    "data-saferedirecturl": "https://tawk.to/workfolio"
  }, "Here")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null))));
};
export default WorkfolioMaintenance;